export const removeCookie = (name: string) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};

export const addCookie = (name: string, value: string, maxAge?: number) => {
  document.cookie = `${name}=${value};${maxAge ? `max-age=${maxAge};` : ""} path=/`;
};

export const getAllCookies = () => {
  return document.cookie
    .split(";")
    .map((cookie) => cookie.split("=").map((c) => c.trim()));
};

export const removeCookies = () => {
  getAllCookies().forEach((cookie) => {
    removeCookie(cookie[0]);
  });
};
